import { useTranslation } from 'react-i18next';
import { CheckCircle2, MinusCircle, Info } from 'lucide-react';
import { Modal } from '../../../shared/ui/Modal';
import { Button } from '../../../shared/ui/Button';
import type { Quota } from '../../../shared/api/types';
import { useQuotaResetInfo } from '../useQuotaResetInfo';

export function QuotaPausedModal({
  open,
  onOpenChange,
  quota,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  quota?: Quota;
}) {
  const { t } = useTranslation();
  const { resetDate, resetLabel } = useQuotaResetInfo(quota);
  const canItems = t('quota.pausedModal.can').split('\n');

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      className="sm:max-w-xl"
      title={t('quota.pausedModal.title', { date: resetDate })}
      description={t('quota.pausedModal.subtitle', { reset: resetLabel })}
    >
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-xl bg-success-soft/60 p-3.5">
          <p className="flex items-center gap-2 text-sm font-semibold text-success-text">
            <CheckCircle2 className="h-4 w-4" /> {t('quota.pausedModal.canTitle')}
          </p>
          <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-fg-muted">
            {canItems.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
        </div>
        <div className="rounded-xl bg-page p-3.5">
          <p className="flex items-center gap-2 text-sm font-semibold text-fg-muted">
            <MinusCircle className="h-4 w-4" /> {t('quota.pausedModal.pausedColTitle')}
          </p>
          <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-fg-muted">
            <li>{t('quota.pausedModal.pausedCol')}</li>
          </ul>
        </div>
      </div>

      <div className="mt-3 flex gap-3 rounded-xl bg-info-soft p-3.5">
        <Info className="mt-0.5 h-4 w-4 shrink-0 text-info" />
        <div>
          <p className="text-sm font-semibold text-fg">{t('quota.pausedModal.noteTitle')}</p>
          <p className="mt-0.5 text-sm text-fg-muted">{t('quota.pausedModal.note')}</p>
        </div>
      </div>

      {/* Замечание РТК W1/M3: «Закрыть» — по центру, на мобильной — во всю ширину. */}
      <div className="mt-6 flex justify-center">
        <Button
          className="w-full sm:w-auto sm:min-w-40"
          onClick={() => {
            onOpenChange(false);
          }}
        >
          {t('common.close')}
        </Button>
      </div>
    </Modal>
  );
}
